export default {
  "HELLO": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HELLO"])},
  "Account": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account"])},
  "List with us": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["List with us"])},
  "user": {
    "upcoming": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upcoming Bookings"])},
    "become": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Become a host"])}
  },
  "host": {
    "New Orders": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Orders"])},
    "Booking Calendar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Booking Calendar"])}
  }
}